export const registeredUserInformation = {
    Johnson926535: { allowedSubjects: ['mathematics'] },
    guest982: { allowedSubjects: ['mathematics'] }
};

